import React, { useEffect, useState } from "react";
import {
  Box,
  Grid,
  Typography,
  IconButton,
  Paper,
  Chip,
  Button,
  List,
  MenuItem,
  Tooltip,
} from "@mui/material";
import { DatePicker, Input, Table, Select } from "antd";
import { AllTypoFontStyles, EventManagementStyles } from "../../Styles/styles";
import {
  ClockIcn,
  RafflesHistoryIcon,
  SearchIcn,
  UserTicketIcon,
  VisibilityOnIcon,
} from "../../Svg/icons";
import dayjs from "dayjs";
import { useGetBookedEventsQuery } from "../../Redux/apis/ApiSlice";
import SwipeableDrawer from "@mui/material/SwipeableDrawer";
import Divider from "@mui/material/Divider";
import ListItem from "@mui/material/ListItem";
import ListItemText from "@mui/material/ListItemText";
import DownloadIcon from "@mui/icons-material/Download";
import jsPDF from "jspdf";
import { useNavigate } from "react-router-dom";
import QuikTixWhiteLogo from "../../Images/GX_Logo_White_No_Bg.png";
const useTimer = (targetDate) => {
  const calculateTimeLeft = () => {
    const now = dayjs();
    const difference = targetDate.diff(now);

    let timeLeft = {};

    if (difference > 0) {
      timeLeft = {
        Days: Math.floor(difference / (1000 * 60 * 60 * 24)),
        Hours: Math.floor((difference / (1000 * 60 * 60)) % 24),
        Minutes: Math.floor((difference / 1000 / 60) % 60),
        Seconds: Math.floor((difference / 1000) % 60),
      };
    } else {
      timeLeft = {
        Days: "00",
        Hours: "00",
        Minutes: "00",
        Seconds: "00",
      };
    }

    return timeLeft;
  };

  const [timeLeft, setTimeLeft] = useState(calculateTimeLeft());

  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(calculateTimeLeft());
    }, 1000);

    return () => clearInterval(timer);
  }, [targetDate]);

  return timeLeft;
};

export default function MyBookings() {
  // const { data: bookings, isLoading, isError } = useGetBookedEventsQuery();

  const [eventName, setEventName] = useState("");
  const [organizerName, setOrganizerName] = useState("");
  const [status, setStatus] = useState("");
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const navigate = useNavigate();
  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(3);

  const {
    data: bookings,
    isLoading,
    isError,
  } = useGetBookedEventsQuery(
    {
      eventName,
      organizerName,
      status,
      startDate: startDate ? startDate.toISOString() : undefined,
      endDate: endDate ? endDate.toISOString() : undefined,
      page,
      limit,
    },
    { refetchOnMountOrArgChange: true }
  );

  // Map API data2 to the format needed for the table
  let UpcomingEventTime = dayjs(bookings?.bookings[0]?.event?.time).format(
    "hh:mm A"
  );
  const dateEvent = bookings?.bookings[0]?.event?.startDateTime;
  let UpcomingEventDate = dateEvent
    ? dayjs(dateEvent).format("MM/DD/YYYY")
    : "";

  const rows = React.useMemo(() => {
    if (isLoading) return [];
    if (isError) return [];
    if (!bookings || !bookings.bookings) return [];

    //
    return bookings.bookings.map((booking) => {
      // Process ticketTypes
      const ticketTypesFormatted =
        booking?.ticketTypes
          ?.filter((ticket) => ticket.quantity > 0) // Exclude tickets with quantity 0
          ?.map(
            (ticket) =>
              `${ticket.type} ${ticket.quantity}  $${ticket.totalPrice}`
          )
          .join(", ") || ""; // Join into a readable string
      const organizer =
        booking?.event?.eventOrganizers[0]?.user?.fullName || "";
      return {
        id: booking.id,
        eventId: booking.eventId,
        name: organizer,
        startDateTime: booking.event?.startDateTime,
        location: booking.event?.location,
        ticketID: booking.event?.eventName,
        bookingDate: new Date(booking.date).toLocaleDateString(),
        createdOn: new Date(booking.created_at).toLocaleDateString(),
        total: booking.totalPrice,
        status: booking.event?.status,
        qrCode: booking.qrCode,
        code: booking.code,
        ticketTypes: ticketTypesFormatted,
      };
    });
  }, [bookings, isLoading, isError]);
  const [hours, minutes, seconds] = UpcomingEventTime.split(":").map((unit) =>
    unit.padStart(2, "0")
  );
  const eventDate = dayjs()
    .add(hours, "hours")
    .add(minutes, "minutes")
    .add(seconds, "seconds");
  const timer = useTimer(eventDate);

  const data2 = [
    {
      cardID: 1,
      title: "Total Bookings",
      value: bookings?.totalCount,
      icon: <UserTicketIcon />,
    },
    {
      cardID: "2",
      title: `"${bookings?.upNextEvent || "No upcoming event"}"`,
      value: 75,
      icon: <ClockIcn />,
    },
  ];
  const { Option } = Select;

  const statusOptions = [
    { value: "upcoming", label: "Upcoming" },
    { value: "live", label: "Live" },
    { value: "finish", label: "Finish" },
  ];
  const renderStatusChip = (status) => {
    let color;
    let label;
    let backgroundColor;

    switch (status) {
      case "upcoming":
        color = "purple";
        backgroundColor = "rgba(128, 0, 128, 0.1)";
        label = "Upcoming";
        break;
      case "Upcoming":
        color = "purple";
        backgroundColor = "rgba(128, 0, 128, 0.1)";
        label = "Upcoming";
        break;
      case "live":
        color = "red";
        backgroundColor = "rgba(250, 0, 0, 0.1)";
        label = "Live";
        break;
      case "Live":
        color = "red";
        backgroundColor = "rgba(250, 0, 0, 0.1)";
        label = "Live";
        break;
      case "cancel":
        color = "grey";
        backgroundColor = "rgba(128, 128, 128, 0.1)";
        label = "Cancel";
        break;
      case "Cancel":
        color = "grey";
        backgroundColor = "rgba(128, 128, 128, 0.1)";
        label = "Cancel";
        break;
      case "finish":
        color = "green";
        backgroundColor = "rgba(0, 128, 0, 0.1)";
        label = "Finish";
        break;
      case "Finish":
        color = "green";
        backgroundColor = "rgba(0, 128, 0, 0.1)";
        label = "Finish";
        break;
      default:
        color = "grey";
        backgroundColor = "rgba(128, 128, 128, 0.1)";
        label = "Unknown";
    }

    return (
      <Chip
        icon={
          <svg
            width="5"
            height="6"
            viewBox="0 0 5 6"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <circle cx="2.5" cy="3" r="2.5" fill={color} />
          </svg>
        }
        size="small"
        label={label}
        style={{
          color: color,
          backgroundColor: "transparent",
          fontWeight: 500,
          fontSize: "12px",
          height: "22px",
          justifyContent: "left",
          // gap: 2,
          // padding: 2,
          width: "100%",
          borderRadius: "4px",
        }}
      />
    );
  };
  // --->
  const [drawerOpen, setDrawerOpen] = React.useState(false);
  const [selectedRow, setSelectedRow] = React.useState(null);
  function formatDate(dateString) {
    const date = new Date(dateString);
    const day = String(date.getDate()).padStart(2, "0"); // Ensures 2-digit day
    const month = String(date.getMonth() + 1).padStart(2, "0"); // Months are 0-indexed
    const year = date.getFullYear();
    return `${month}/${day}/${year}`;
  }
  const handleViewClick = (record) => {
    setSelectedRow(record);
    //setDrawerOpen(true);

    navigate("/TicketsDetails", {
      state: {
        bookingId: record?.id,
        eventId: record?.eventId,
      },
    });
  };

  const handleDrawerClose = () => {
    setDrawerOpen(false);
  };

  const columns = [
    {
      dataIndex: "name",
      title: <span className="header-style">Organizer</span>,
      key: "name",
      width: 150,
      render: (text) => (
        <Box sx={{ display: "flex", alignItems: "center" }}>{text}</Box>
      ),
    },
    {
      dataIndex: "ticketID",
      width: 120,
      title: <span className="header-style">Event Name</span>,
      key: "ticketID",
    },
    {
      dataIndex: "bookingDate",
      width: 120,
      title: <span className="header-style">Booking Date</span>,
      key: "bookingDate",
    },
    {
      dataIndex: "location",
      width: 120,
      title: <span className="header-style">Location</span>,
      key: "location",
    },
    {
      dataIndex: "total",
      width: 120,
      title: <span className="header-style">Ticket Price</span>,
      key: "total",
      render: (text, record) => `$ ${text}`,
    },
    {
      dataIndex: "status",
      width: 100,
      title: "Status",
      key: "status",
      render: (text, record) => (
        <div style={{ whiteSpace: "nowrap", textAlign: "center", width: 100 }}>
          {renderStatusChip(record.status)}
        </div>
      ),
    },
    {
      dataIndex: "action",
      width: 180,
      title: <span className="header-style">Action</span>,
      key: "action",
      render: (text, record) => (
        <>
          <IconButton
            color="primary"
            aria-label="view"
            onClick={() => handleViewClick(record)}
          >
            <VisibilityOnIcon />
          </IconButton>
        </>
      ),
    },
  ];
  const labelMapping = {
    id: "ID",
    name: "Event Name:",
    date: "Event Date",
    location: "Location:",
    ticketID: "Ticket ID",
    bookingDate: "Booking Date:",
    // createdOn: "Created On",
    total: "Total Amount:",
    status: "Status:",
    qrCode: "QR Code",
  };
  const list = () => {
    return (
      <Box
        sx={{
          width: { xs: "100vw", sm: 350 },
          padding: "24px 24px 24px 38px",
          backgroundColor: "#f5f5f5",
          marginTop: "15%",
        }} // Existing styles
        role="presentation"
        // onClick={handleDrawerClose}
        onKeyDown={handleDrawerClose}
      >
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            marginBottom: 1,
            width: "100%",
          }}
        >
          <Typography
            variant="h6"
            ml={1.4}
            component="div"
            sx={{ flexGrow: 1 }}
          >
            Ticket Invoice
          </Typography>
          <IconButton onClick={handleDownload} color="primary">
            <DownloadIcon />
          </IconButton>
        </Box>
        <List>
          <Divider />
          <ListItem>
            <ListItemText
              primary={
                <>
                  <Typography
                    component="span"
                    sx={{ fontWeight: "bold", display: "inline" }}
                  >
                    Event Name:
                  </Typography>
                  <Typography
                    component="span"
                    sx={{ display: "inline", marginLeft: 1 }}
                  >
                    {selectedRow?.ticketID || ""}
                  </Typography>
                </>
              }
            />
          </ListItem>

          <ListItem>
            <ListItemText
              primary={
                <>
                  <Typography
                    component="span"
                    sx={{ fontWeight: "bold", display: "inline" }}
                  >
                    Event Date:
                  </Typography>
                  <Typography
                    component="span"
                    sx={{ display: "inline", marginLeft: 1 }}
                  >
                    {selectedRow?.startDateTime &&
                      dayjs(selectedRow?.startDateTime).format("MM/DD/YYYY")}
                  </Typography>
                </>
              }
            />
          </ListItem>
          {selectedRow &&
            Object.entries(selectedRow).map(
              ([key, value]) =>
                key !== "ticketID" &&
                key !== "eventId" &&
                key !== "qrCode" &&
                key !== "code" &&
                key !== "id" &&
                key !== "createdOn" &&
                key !== "startDateTime" &&
                key !== "date" &&
                key !== "ticketTypes" &&
                key !== "name" && (
                  <ListItem key={key}>
                    <ListItemText
                      primary={
                        <>
                          <Typography
                            component="span"
                            sx={{ fontWeight: "bold", display: "inline" }}
                          >
                            {/* {key.replace(/([A-Z])/g, " $1").trim()}: */}
                            {labelMapping[key]}
                          </Typography>
                          <Typography
                            component="span"
                            sx={{ display: "inline", marginLeft: 1 }}
                          >
                            {key === "total" ? `$ ${value}` : value}
                          </Typography>
                        </>
                      }
                    />
                  </ListItem>
                )
            )}
          <ListItem>
            <Button
              onClick={() => {
                navigate("/TicketsDetails", {
                  state: {
                    bookingId: selectedRow?.id,
                    eventId: selectedRow?.eventId,
                  },
                });
              }}
            >
              More Detail
            </Button>
            <Button onClick={() => handleDrawerClose()}>Close</Button>
          </ListItem>
        </List>
      </Box>
    );
  };

  const handleDownload = () => {
    if (!selectedRow) return;

    const doc = new jsPDF("p", "pt", "a4"); // Set page to A4

    // Set Background color to brand color (#061F44)
    doc.setFillColor(0, 0, 0); //rgb(0, 0, 0)
    doc.rect(0, 0, 595, 842, "F"); // Fill whole page with brand background color

    // Add GX Tickets Logo
    doc.addImage(QuikTixWhiteLogo, "PNG", 40, 40, 60, 60); // Logo at the top-left corner

    // Title Section with larger and bold text
    doc.setFont("helvetica", "bold");
    doc.setFontSize(30);
    doc.setTextColor(255, 255, 255); // White text for title
    doc.text("INVOICE", 40, 130); // Title text

    // Line after title to separate sections
    doc.setLineWidth(2);
    doc.setDrawColor(255, 255, 255); // White line
    doc.line(40, 135, 550, 135); // Horizontal line under title

    // Event details Section - Using different font weight for labels
    doc.setFontSize(14);
    doc.setFont("helvetica", "normal");
    doc.setTextColor(255, 255, 255); // White text for details

    const details = [
      { label: "Event Name:", value: selectedRow.ticketID },
      // { label: "Organization:", value: selectedRow.organizationName },
      {
        label: "Organizer:",
        value: selectedRow.name,
      },
      {
        label: "Event Date:",
        value: dayjs(selectedRow.startDateTime).format("MM/DD/YYYY"),
      },
      {
        label: "Event Time:",
        value: dayjs(selectedRow.startDateTime).format("hh:mm A"), // Check For proper variable usage
      },
      { label: "Location:", value: selectedRow.location },
      { label: "Total Amount:", value: `$ ${selectedRow.total}` },

      {
        label: "Booking Date:",
        value: dayjs(selectedRow.date).format("MM/DD/YYYY"),
      },
    ];

    let yPosition = 160;
    details.forEach((detail) => {
      // Label (bolder)
      doc.setFont("helvetica", "bold");
      doc.text(detail.label, 40, yPosition);

      // Value (wrapped to fit within the page)
      doc.setFont("helvetica", "normal");
      const wrappedText = doc.splitTextToSize(detail.value, 300); // Adjust width as needed
      wrappedText.forEach((line) => {
        doc.text(line, 205, yPosition); // Align value
        yPosition += 20; // Move down for the next line
      });

      yPosition += 10; // Additional spacing between details
    });

    // Section Divider Line (White line for clear separation)
    yPosition += 10;
    doc.setLineWidth(1);
    doc.setDrawColor(255, 255, 255); // White line
    doc.line(40, yPosition, 550, yPosition);
    yPosition += 20;

    // Ticket Details Section
    doc.setFontSize(16);
    doc.setFont("helvetica", "bold");
    doc.text("Ticket Details", 40, yPosition);
    yPosition += 30;

    // ✅ Format and filter ticket types (exclude those with quantity 0)
    const ticketsArray = Array.isArray(selectedRow.ticketTypes)
      ? selectedRow.ticketTypes
      : selectedRow.ticketTypes?.split(",")?.map((ticket) => {
          const parts = ticket.trim().split(/\s+/);
          return {
            type: parts[0],
            quantity: parseInt(parts[1], 10) || 0,
            price: parts[2] ? `$${parts[2].replace("$", "")}` : "$0",
          };
        });

    const validTickets = ticketsArray?.filter((ticket) => ticket.quantity > 0);

    if (validTickets.length > 0) {
      doc.setFontSize(14);
      validTickets.forEach((ticket) => {
        doc.setFont("helvetica", "bold");
        doc.text(`Ticket Type:`, 40, yPosition);
        doc.setFont("helvetica", "normal");
        doc.text(ticket.type, 200, yPosition);

        doc.setFont("helvetica", "bold");
        doc.text(`Tickets Booked:`, 40, yPosition + 20);
        doc.setFont("helvetica", "normal");
        doc.text(`${ticket.quantity}`, 200, yPosition + 20);

        // doc.setFont("helvetica", "bold");
        // doc.text(`Total Price:`, 40, yPosition + 40);
        // doc.setFont("helvetica", "normal");
        // doc.text(ticket.price, 200, yPosition + 40);

        yPosition += 60; // Increased spacing for better separation
      });
    } else {
      doc.setFontSize(14);
      doc.setFont("helvetica", "italic");
      doc.text("No valid tickets purchased.", 40, yPosition);
    }

    // Footer Section with a subtle gradient or line (styled)
    doc.setFontSize(10);
    doc.setFont("helvetica", "italic");
    doc.setTextColor(255, 255, 255); // White for footer text
    doc.text("Thank you for choosing GX Tickets!", 40, 770);
    doc.text("Visit www.gxtickets.com for more details.", 40, 790);

    // Footer Line
    doc.setLineWidth(2);
    doc.line(40, 800, 550, 800);

    // Save the PDF with a user-friendly filename
    doc.save(`ticket_invoice_${selectedRow.ticketID}.pdf`);
  };

  useEffect(() => {
    setPage(1);
  }, [eventName, organizerName, status, startDate, endDate]);

  return (
    <Grid container>
      {/* <AddYourEventButton/> */}
      <Paper elevation={1} sx={{ p: 1, width: "100%" }}>
        <Box sx={{ flexGrow: 1, padding: 1 }}>
          <Grid container spacing={2}>
            {data2.map((item, index) => (
              <Grid item xs={12} md={6} lg={6} xl={4} key={index}>
                <Paper
                  elevation={1}
                  sx={{
                    borderRadius: 3,
                    padding: 1.5,
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "space-between",
                    height: 125,
                  }}
                >
                  <Typography sx={AllTypoFontStyles.CommonCardsTitleTypo}>
                    {item.cardID === "2" ? (
                      <>
                        Up Next Event{" "}
                        <span style={{ fontWeight: 400 }}>{item.title}</span>
                      </>
                    ) : (
                      item.title
                    )}{" "}
                  </Typography>
                  <Box
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "space-between",
                    }}
                  >
                    <Grid>{item.icon}</Grid>
                    {timer && item.cardID === "2" ? (
                      <Box style={useStyles.section}>
                        <Box style={useStyles.timer}>
                          {/* {Object.entries(timer).map(([unit, time], index) => ( */}
                          <>
                            <Box key={index}>
                              {UpcomingEventDate ? (
                                <Typography
                                  sx={{
                                    fontWeight: 500,
                                    fontSize: {
                                      xs: "1rem",
                                      md: "1.8rem",
                                    },
                                    whiteSpace: "nowrap",
                                  }}
                                >
                                  {UpcomingEventDate === ""
                                    ? ""
                                    : formatDate(UpcomingEventDate)}
                                </Typography>
                              ) : (
                                "No Upcoming"
                              )}
                            </Box>
                          </>
                          {/* ))} */}
                        </Box>
                      </Box>
                    ) : item.cardID === "3" ? (
                      <Box sx={{ padding: 4 }}>
                        <Button>
                          <RafflesHistoryIcon />
                        </Button>
                      </Box>
                    ) : (
                      <Typography
                        sx={{
                          ...AllTypoFontStyles.CommonCardsValueTypo,
                          fontSize: {
                            xs: "1rem",
                            md: index === 2 ? "1.3rem" : "1.8rem",
                          },
                        }}
                      >
                        <Tooltip title={item.value} arrow>
                          <span
                            style={{
                              whiteSpace: "nowrap",
                              overflow: "hidden",
                              textOverflow: "ellipsis",
                              maxWidth: "230px",
                            }}
                          >
                            {item.value}
                          </span>
                        </Tooltip>
                      </Typography>
                    )}
                  </Box>
                </Paper>
              </Grid>
            ))}
          </Grid>
        </Box>
        <Grid>
          <Box p={2} mt={3}>
            <Typography
              gutterBottom
              sx={{
                ...AllTypoFontStyles.CommonTypo1,
                fontWeight: "bold",
                mb: 2,
              }}
            >
              Manage Events
            </Typography>

            <Grid container spacing={2}>
              {/* Search Input */}
              <Grid item xs={12} sm={6} lg={4}>
                <Input
                  prefix={<SearchIcn />}
                  size="large"
                  placeholder="Search Event Name"
                  sx={{ ...EventManagementStyles.SearchField, width: "100%" }}
                  value={eventName}
                  onChange={(e) => setEventName(e.target.value)}
                  fullWidth
                />
              </Grid>

              {/* Status Filter - Fixing Full Width Issue */}
              <Grid
                item
                xs={12}
                sm={6}
                lg={2}
                sx={{ "& .ant-select": { width: "100%" } }}
              >
                <Select
                  placeholder="Status"
                  size="large"
                  sx={{
                    ...EventManagementStyles.SearchField,
                    width: "100%", // Forces full width
                  }}
                  value={status}
                  onChange={(value) => setStatus(value)}
                  displayEmpty
                  fullWidth
                >
                  <MenuItem value="">All Events</MenuItem>
                  {statusOptions.map((option) => (
                    <MenuItem key={option.value} value={option.value}>
                      {renderStatusChip(option.value)}
                    </MenuItem>
                  ))}
                </Select>
              </Grid>

              {/* Start Date Picker - Fixing Full Width */}
              <Grid
                item
                xs={12}
                sm={6}
                lg={3}
                sx={{ "& .ant-picker": { width: "100%" } }}
              >
                <DatePicker
                  placeholder="Select Start Date"
                  size="large"
                  sx={{
                    ...EventManagementStyles.SearchField,
                    width: "100%", // Ensures it takes full width
                  }}
                  selected={startDate}
                  onChange={(date) => setStartDate(date)}
                  format="MM/DD/YYYY"
                  fullWidth
                />
              </Grid>

              {/* End Date Picker - Fixing Full Width */}
              <Grid
                item
                xs={12}
                sm={6}
                lg={3}
                sx={{ "& .ant-picker": { width: "100%" } }}
              >
                <DatePicker
                  placeholder="Select End Date"
                  size="large"
                  sx={{
                    ...EventManagementStyles.SearchField,
                    width: "100%", // Ensures it takes full width
                  }}
                  selected={endDate}
                  onChange={(date) => setEndDate(date)}
                  format="MM/DD/YYYY"
                  fullWidth
                />
              </Grid>
            </Grid>
          </Box>
        </Grid>
        <Grid item sx={{ padding: 1 }} xs={12}>
          <Box
            sx={{
              height: { xl: "65vh", lg: "100vh", md: "65vh", xs: "100%" },
              fontSize: 14,
              fontWeight: "400px",
            }}
          >
            {rows.length > 0 ? (
              <Table
                columns={columns}
                dataSource={rows}
                pagination={{
                  current: page,
                  pageSize: limit,
                  total: bookings?.totalCount || 0, // total from backend response
                  onChange: (page, pageSize) => {
                    setPage(page);
                    setLimit(pageSize);
                  },
                  showSizeChanger: true,
                }}
                scroll={{ y: 500 }}
                rowKey="id"
              />
            ) : isLoading ? (
              <Typography
                sx={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                Loading...
              </Typography>
            ) : (
              <Typography
                sx={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                No events
              </Typography>
            )}
          </Box>
          <SwipeableDrawer
            anchor="right"
            open={drawerOpen}
            onClose={handleDrawerClose}
            onOpen={() => {}}
          >
            {list()}
          </SwipeableDrawer>
        </Grid>
      </Paper>
    </Grid>
  );
}

const useStyles = {
  root: {
    display: "flex",
    justifyContent: "space-between",
    padding: "16px",
    borderRadius: "8px",
    boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
  },
  section: {
    margin: "0 1px",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
  },
  icon: {
    marginBottom: "8px",
  },
  timer: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    gap: "4px",
  },
  historyLink: {
    color: "#1a73e8",
    cursor: "pointer",
  },
};
